import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class TipoRevisionService {

  controller: string = "tipo-revision/"
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.sesion.token,
    })
  };
  
  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) {}

  index(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + "index-select", this.sesion.headers)
  }

  view(id: number): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + `view/${id}`, this.sesion.headers)
  }

  create(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + "create", data, this.sesion.headers);
  }

  update(data: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + `update/${data.id}`, data, this.sesion.headers);
  }

  activate(id: number): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + `activate/${id}`, {}, this.sesion.headers)
  }

  deactivate(id: number): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + `deactivate/${id}`, {}, this.sesion.headers)
  }

  delete(id: number): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + `destroy/${id}`, this.sesion.headers)
  }
  
}
